import {Injectable, OnDestroy} from "@angular/core";
import {DevExtremeThemeOverride, PrimeNGThemeOverride, ThemeEnum, ThemeEnumDisplayLabel, ThemeEnumLabel, ThemeLabeltoEnum} from "../enums/theme-enum";
import {BehaviorSubject, Subscription} from "rxjs";
import {Auth2Service} from "./security/auth2.service";
import {UtilsService} from "../utils/utils.service";
import {Utilisateur} from "../utilisateur";

@Injectable({
  providedIn: 'root',
})
export class ThemeService implements OnDestroy {

  /**
   * Attention, le thème de la page de chargement est définie dans index.html theme="..."
   * Le reste sinon est bien basé sur cette variable
   */
  private defaultTheme: ThemeEnum = ThemeEnum.YONI;

  private devextremeThemeOverrideKey = 'devextreme-theme-override'
  private primengThemeOverrideKey = 'primeng-theme-override'

  subOnUserConnection: Subscription;

  public themesList = []

  constructor(private utilsSvc: UtilsService,
              private auth2Svc: Auth2Service) {
    this.themesList = Object.entries(ThemeEnumDisplayLabel).map(([key, libelle]) => ({
      key: Number(key),
      libelle: libelle
    }));

    this.resetTheme(auth2Svc.utilisateur);
    this.subOnUserConnection = auth2Svc.user$.subscribe(user => {
      this.resetTheme(user);
    })
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOnUserConnection);
  }

  private resetTheme = (user: Utilisateur) => {
    this.applyTheme(this.getSavedThemeLabel(user));
  }

  setTheme(theme: ThemeEnum) {
    localStorage.setItem(this.getLocalStorageThemeVariableName(this.auth2Svc.utilisateur), this.getThemeLabel(theme));
    this.resetTheme(this.auth2Svc.utilisateur);
  }

  private getSavedThemeLabel(user: Utilisateur): ThemeEnum {
    return ThemeLabeltoEnum[localStorage.getItem(this.getLocalStorageThemeVariableName(user))] ?? this.defaultTheme; // Valeur par défaut si rien n'est sauvegardé
  }

  public getThemeLabel = (theme: ThemeEnum) => {
    return ThemeEnumLabel[theme];
  }

  private getLocalStorageThemeVariableName = (user: Utilisateur) => {
    return `${user.username}/theme`;
  }

  getThemeList() {
    return this.themesList;
  }

  getCurrentTheme = () => {
    return this.getSavedThemeLabel(this.auth2Svc.utilisateur);
  }

  private applyTheme(theme: ThemeEnum) {
    document.documentElement.setAttribute('theme', this.getThemeLabel(theme));
    this.applyDevExtremeThemeOverride(theme);
    this.applyPrimeNGThemeOverride(theme);
  }

  private applyPrimeNGThemeOverride(theme: ThemeEnum) {
    const subTheme = PrimeNGThemeOverride[theme];
    let link = document.getElementById(this.primengThemeOverrideKey) as HTMLLinkElement | null;

    if (subTheme) {
      if (!link) {
        link = document.createElement("link");
        link.id = this.primengThemeOverrideKey;
        link.rel = "stylesheet";
        document.head.appendChild(link);
      }
      link.href = `assets/primeng/theme.${subTheme}.css`;
    } else if (link) {
      link.remove();
    }
  }

  private applyDevExtremeThemeOverride(theme: ThemeEnum) {
    const subTheme = DevExtremeThemeOverride[theme];
    let link = document.getElementById(this.devextremeThemeOverrideKey) as HTMLLinkElement | null;

    if (subTheme) {
      if (subTheme && !link) {
        link = document.createElement("link");
        link.id = this.devextremeThemeOverrideKey;
        link.rel = "stylesheet";
        document.head.appendChild(link);
      }

      if (subTheme && link) {
        link.href = `assets/devextreme/dx.generic.${subTheme}.css`;
      }
    } else if (link) {
      link.remove();
    }

  }
}
